import React, { useEffect, useState } from 'react';
import avatar from '../../../assets/profile.webp';
import convertToBase64 from '../../../helper/Convert';
import { TextField, Button, CircularProgress, Box, Alert, Stack } from '@mui/material';
import { fetchOrganizationProfile, updateOrganizationProfile } from '../../../helper/organizationsApis';

const OrganizationProfile = () => {
  const [formData, setFormData] = useState({
    name: '',
    userEmail: '',
    mobile: '',
    companyName: '',
    profilePic: '',
  });

  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');
  const [successMsg, setSuccessMsg] = useState('');

 useEffect(() => {
  const loadProfile = async () => {
    setLoading(true);
    try {
      const data = await fetchOrganizationProfile();
      setFormData(data);
    } catch (err) {
      //console.error('Error fetching profile:', err);
      setError('Failed to load profile');
    } finally {
      setLoading(false);
    }
  };

  loadProfile();
}, []);

  useEffect(() => {
    if (error || successMsg) {
      const timer = setTimeout(() => {
        setError('');
        setSuccessMsg('');
      }, 4000);
      return () => clearTimeout(timer);
    }
  }, [error, successMsg]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setError('');
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const onUpload = async (e) => {
    const file = e.target.files[0];
    const maxSize = 50 * 1024; // 100KB
  
    if (file) {
      if (file.size > maxSize) {
        setError('Profile picture must be under 50KB');
        return;
      }
  
      const base64 = await convertToBase64(file);
      setFormData((prev) => ({ ...prev, profilePic: base64 }));
    }
  };  

  const handleSubmit = async (e) => {
  e.preventDefault();
  setSaving(true);
  setError('');
  setSuccessMsg('');
  try {
    const res = await updateOrganizationProfile(formData);
    setSuccessMsg(res.message);
  } catch (err) {
    //console.error('Error updating profile:', err);
    setError('Failed to update profile');
  } finally {
    setSaving(false);
  }
};

  if (loading) return <CircularProgress />;

  return (
    <Box maxWidth={600} mx="auto" p={2} sx={{ marginTop :"80px"}}>
      {error && error !== 'Failed to load profile' && (
        <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>
      )}
      {successMsg && <Alert severity="success" sx={{ mb: 2 }}>{successMsg}</Alert>}

      <form onSubmit={handleSubmit}>
        <Stack spacing={2}>
          <Box sx={{ display: 'flex', justifyContent: 'center', mb: 2 }}>
            <label htmlFor="profile">
              <img
                src={formData.profilePic || avatar}
                alt="Profile"
                style={{ width : 100, height : 100, borderRadius: '50%', cursor: 'pointer' }}
              />
            </label>
            <input onChange={onUpload} type="file" id="profile" name="profile" style={{ display: 'none' }} />
          </Box>

          <TextField label="Username" name="name" value={formData.name} onChange={handleChange} fullWidth />
          <TextField label="Email" name="userEmail" value={formData.userEmail} onChange={handleChange} fullWidth />
          <TextField label="Mobile" name="mobile" value={formData.mobile} onChange={handleChange} fullWidth />
          <TextField label="Company Name" name="companyName" value={formData.companyName} required onChange={handleChange} fullWidth />

          <Button type="submit" variant="contained" color="primary" disabled={saving}>
            {saving ? 'Saving...' : 'Update Profile'}
          </Button>
        </Stack>
      </form>
    </Box>
  );
};

export default OrganizationProfile;
